import PropTypes from 'prop-types';
import React from 'react';
import { hoursType } from '@types/index';
import cx from 'classnames';

import Link from '@components/Link';
import './index.scss';
import { faClock } from '@fortawesome/free-regular-svg-icons/faClock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MuseumHours = ({ hours, isMobileNav }) => {
  if (!hours) return null;
  const { isOpenToday, openingTime, closingTime } = hours;

  // Format hours text
  let hoursDisplay = '';
  if (isOpenToday) {
    const formatOptions = {
      timeZone: 'US/Central',
      hour: 'numeric',
      minute: '2-digit',
    };
    const openStr = new Date(openingTime).toLocaleTimeString('en-US', formatOptions).replace('AM', '').replace('PM', '');
    const closeStr = new Date(closingTime).toLocaleTimeString('en-US', formatOptions).replace('AM', '').replace('PM', '');
    hoursDisplay = `Open today: ${openStr} to ${closeStr}`;
  } else {
    hoursDisplay = 'Closed';
  }

  return (
    <div className={cx(isMobileNav ? 'museum-hours-side pl-3 py-2' : 'museum-hours desktop-nav')}>
      <Link to="https://new.smm.org/visit" name="Museum hours">
        {!isMobileNav && (
        <FontAwesomeIcon
          className="icon"
          icon={faClock}
          size="lg"
        />
        )}
        <span className="text-dark">{hoursDisplay}</span>
      </Link>
    </div>
  );
};

MuseumHours.defaultProps = {
  hours: null,
};

MuseumHours.propTypes = {
  hours: hoursType,
  isMobileNav: PropTypes.bool.isRequired,
};

export default MuseumHours;
